/* eslint-disable react/jsx-indent, react/jsx-closing-tag-location */
import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Typography from '@material-ui/core/Typography';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { Stack, SecondaryActionButton } from '@facet-wealth/design';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import onboardingStyles from '../../../../../../Onboarding/Pages/Survey/SurveyStep/StepLibrary/DetailList/Layout/styles';

const styles = (theme) => ({
  ...onboardingStyles(theme),
  addButtonRow: {
    width: '100%',
    textAlign: 'center',
  },
  addButtonRowHidden: {
    display: 'none',
  },
  addButton: {},
  allRemainingText: {
    textAlign: 'center',
    fontWeight: theme.typography.fontWeightBold,
  },
  beneficiaryTextTitle: {
    fontSize: theme.typography.h4.fontSize,
    color: theme.palette.facet.slate,
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: theme.spacing(2),
  },
  beneficiaryTextSubtitle: {
    color: theme.palette.facet.accentGreen,
  },
  beneficiaryBlock: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  editIcon: {
    paddingRight: theme.spacing(1),
  },
  specificPageLink: {
    maxWidth: '250px',
    margin: 'auto',
  },
  rootLegacy: {
    display: 'flex',
    flex: '1',
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: theme.spacing(1),
    '& .MuiFormHelperText-root': {
      position: 'relative',
    },
    '& > .MuiFormLabel-root': {
      whiteSpace: 'nowrap',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
});

function Layout({
  classes,
}) {
  const {
    pageContentResource,
    setPageContentCollection,
  } = usePageContentContext();

  const {
    handleChange,
    metaOverrideSet,
  } = useMetaLayoutContext();

  const beneficiaryListFromType = (beneficiaryType) => {
    return (
      <div className={classes.beneficiaryBlock}>
        <Typography className={classes.beneficiaryTextTitle} variant="h5">
          { pageContentResource.attr(`${beneficiaryType}BeneficiaryText`) }
        </Typography>
        {pageContentResource.attr(`${beneficiaryType}BeneficiaryList`).resources().list().map((beneficiary, i) => {
          return (<MetaControl
            attrName="percentShare"
            resource={beneficiary}
            metaOverrideSet={metaOverrideSet}
            onChange={async (v) => {
              pageContentResource.attr(`${beneficiaryType}BeneficiaryList`).resources().list()[i].attr('percentShare', v);
              handleChange(`${beneficiaryType}BeneficiaryList`, pageContentResource.attr(`${beneficiaryType}BeneficiaryList`));
            }}
            className={classes.rootLegacy}
          />);
        })}
        <Stack justifyContent={'center'} alignItems="flex-start">
          <div test={`${beneficiaryType}-edit-link-button`}>
            <SecondaryActionButton
              size={'sm'}
              icon={'edit'}
              label={pageContentResource.relationship(`edit${beneficiaryType[0].toUpperCase() + beneficiaryType.substring(1)}Beneficiaries`)?.meta('prompt') || 'Edit Beneficiaries'}
              onClick={async () => { const newItemCollection = await pageContentResource.relationship(`edit${beneficiaryType[0].toUpperCase() + beneficiaryType.substring(1)}Beneficiaries`).link('related').get(); setPageContentCollection(newItemCollection); }}
            />
          </div>
        </Stack>
      </div>
    );
  };

  return (
    <PageContentContainer>
      <PageContentTop
        title={pageContentResource.attr('title')}
        subtitle={pageContentResource.attr('subtitle')}
      />
      <Box className={classes.content}>
        { beneficiaryListFromType('primary')}
        { pageContentResource.attr('contingentBeneficiaryList').resources().list().length === 0
          ? <div> {pageContentResource.meta().template().list().filter((field) => field.attr('name') === 'contingentBeneficiaryQuestion')
            .map((field) => {
              return (
                <MetaField
                  notInLayout
                  key={field.id()}
                  attr={field.attr('name')}
                />
              );
            })}
            </div>
          : <div>
              {beneficiaryListFromType('contingent')}
            </div>
        }
      </Box>
    </PageContentContainer>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

Layout.defaultProps = {
};

export default withStyles(styles)(Layout);
